import React, { useState, useEffect } from "react";
import Pageloader from "../../../components/loader";
import {
  BulkRiderBatch,
  BulkRiderShift,
  getShiftMongoIDs,
} from "../../../services/batch.service";
import { getRiderMongoIDs } from "../../../services/riders.service";
import FormShiftRider from "../../../components/forms/FormShiftRider";
import {
  openNotification,
  swalNotification,
} from "../../../components/alret/notificztion";

import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Table,
  Typography,
  Button,
  Result,
  message,
  Upload,
  Space,
} from "antd";
import {
  UploadOutlined,
  RollbackOutlined,
  DownloadOutlined,
  ClockCircleOutlined,
  PercentageOutlined,
  ConsoleSqlOutlined,
} from "@ant-design/icons";
import { validationErrors } from "../../../utils/Helpers";
import { Link } from "react-router-dom";

const { Title } = Typography;

const RiderShiftBulkAssignment = () => {
  const navigate = useNavigate();

  const pagename = "Shift";
  const [errMsg, setErrMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const [uploadBulkData, setUploadBulkData] = useState([]);
  const [showSubmitLoder, setShowSubmitLoder] = useState(false);

  // useEffect(() => {
  //   if (data) {
  //     setErrMsg(null);
  //   }
  // }, [data]);
  // useEffect(() => {
  //   if (errMsg) {
  //     setData(null);
  //   }
  // }, [errMsg]);

  const [form] = Form.useForm();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [dataForApi, setDataForApi] = useState(null);
  const [editingKey, setEditingKey] = useState("");
  const [error, setError] = useState("");
  const [formError, setFormError] = useState([]);

  useEffect(() => {
    if (dataForApi) {
      setDataForApi(null);
    }
    if (data) {
      convertDataForApi(data);
    }
  }, [data]);

  useEffect(() => {
    // console.log("api data =>>", dataForApi);
  }, [dataForApi]);

  const convertDataForApi = () => {
    // console.log("Executing");
    let dataToConvert = [];
    data.map((item, idx) => {
      const shiftDto = {
        tszone: item.zone,
        tsstartTimeInSec: convertDateToSecond(item.startTime),
        tsshiftDuration: item.shiftDuration,
        tsslots: item.slots,
      };
      dataToConvert.push(shiftDto);
    });
    setDataForApi(dataToConvert);
    // dataToConvert = null;
  };

  const isEditing = (record) => record.zone === editingKey;

  const convertDateToSecond = (payload) => {
    // console.log("payload => ", payload);
    const newStartTime = new Date(payload);
    return newStartTime.valueOf();
  };

  // const readExcel = (file) => {
  //   console.log(file);
  //   const promise = new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.readAsArrayBuffer(file);
  //     fileReader.onload = (e) => {
  //       const bufferArray = e.target.result;
  //       const wb = XLSX.read(bufferArray, { type: "buffer" });
  //       const wsname = wb.SheetNames[0];
  //       const ws = wb.Sheets[wsname];
  //       const data = XLSX.utils.sheet_to_json(ws);
  //       resolve(data);
  //     };
  //     fileReader.onerror = (error) => {
  //       reject(error);
  //     };
  //   });
  //   promise.then((d) => {
  //     console.log(d);
  //     setData(d);
  //   });
  // };

  const edit = (record) => {
    form.setFieldsValue({
      zone: "",
      startTime: "",
      shiftDuration: "",
      slots: "",
      ...record,
    });
    setEditingKey(record.zone);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }

      // console.log(newData);
    } catch (errInfo) {
      // console.log("Validate Failed:", errInfo);
    }
  };

  const columns = [
    {
      title: "Rider ID",
      dataIndex: "riderId",
      render: (text, record, index) => (
        <Input
          value={text}
          name="riderId"
          // onChange={onInputChange("riderId", index)}
          // // error={!!error}
          // // status={error ? "error" : ""}
          // prefix={<ClockCircleOutlined />}
        />
      ),
    },
    {
      title: "Batch ID",
      dataIndex: "batchId",
      render: (text, record, index) => (
        <Input
          value={text}
          name="batchId"
          onChange={onInputChange("batchId", index)}
          // // error={!!error}
          // // status={error ? "error" : ""}
          // prefix={<ClockCircleOutlined />}
        />
      ),
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "age" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = () => {
    const formData = new FormData();

    // console.log("up data", dataForApi);
    // fileList.forEach((file) => {
    //   formData.append("files[]", file);
    // });

    return;
    // fileList.forEach((file) => {
    //   formData.append("files[]", file);
    // });
    // console.log(uploadBulkData);
    // return;

    setUploading(true); // You can use any AJAX library you like

    fetch("https://www.mocky.io/v2/5cc8019d300000980a055e76", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())

      .then(() => {
        setFileList([]);
        message.success("upload successfully.");
      })

      .catch(() => {
        message.error("upload failed.");
      })

      .finally(() => {
        setUploading(false);
      });
  };

  const props = {
    // readExcel: (file) => {
    //   console.log(file);
    // },
    onRemove: (file) => {
      // console.log("onRemove", file);
      setData("");
      setInitialValues(null);

      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setLoading(true);
      // setData("");
      // // const index = fileList.indexOf(file);
      // // const newFileList = fileList.slice();
      // // newFileList.splice(index, 1);
      // setFileList([...fileList, ""]);

      // console.log("beforeUpload", file);
      const promise = new Promise((resolve, reject) => {
        setFileList([...fileList, ""]);

        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = async (e) => {
          const bufferArray = e.target.result;
          const wb = XLSX.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);
          // console.log("csv data", data);
          let shiftIDs = [];
          let riderIDs = [];
          data.map((v, i) => {
            shiftIDs.push(v.shiftId);
            riderIDs.push(v.riderId);
          });
          // console.log("shift IDs ", shiftIDs, "rider IDs", riderIDs);
          // let displayIds = "";
          const ShiftDisplayIds = { displayIds: shiftIDs };
          const RiderDisplayIds = { displayIds: riderIDs };
          // console.log("display ids", displayIds);
          // return null;
          const headers = {
            "Content-Type": "application/json",
          };

          let result = await shiftRiderMongoIDs(
            ShiftDisplayIds,
            RiderDisplayIds
          );
          // console.log("After csv upload result", result);
          let shift_data = [];
          // result.sMIds.map((v,i) => {
          //  console.log('value sMId rMId', result.rMIds[i].display_id);
          // //  rider_shift_data.shiftId = v.display_id
          // //  rider_shift_data.riderId = result.rMIds[i].display_id
          //  shift_data.push({shiftId: v.display_id, zone: v.zone.zoneName ,riderId: result.rMIds[i].display_id, rider: result.rMIds[i].fullName})
          // })
          if (result.sMIds.length < 1) {
            swalNotification(
              "Invalid Shift IDs",
              "Please add correct IDs of shift",
              error
            );
          } else if (result.rMIds.length < 1) {
            swalNotification(
              "Invalid Rider IDs",
              "Please add correct IDs of rider",
              error
            );
          }
          if (result.sMIds.length > 0 && result.rMIds.length > 0) {
            data.map((v, i) => {
              // console.log("shift display id ", v);
              // return null;
              let shiftId = "";
              let shiftDisplayId = "";
              let shiftZone = "";
              let riderId = "";
              let riderDisplayId = "";
              let rider = "";
              result.sMIds &&
                result.sMIds.length > 0 &&
                result.sMIds.map((vv, ii) => {
                  // console.log(
                  //   "value shift id and display id",
                  //   v.shiftId,
                  //   vv.display_id
                  // );
                  if (v.shiftId == vv.display_id) {
                    // console.log("get shift single mongo id", vv._id);
                    shiftDisplayId = vv.display_id;
                    shiftId = vv._id;
                    shiftZone = vv.zone.zoneName;
                  }
                });
              result.rMIds &&
                result.rMIds.length > 0 &&
                result.rMIds.map((vvv, ii) => {
                  // console.log("get rider single mongo id", vvv._id);
                  // console.log(
                  //   "value shift id and display id",
                  //   v.riderId,
                  //   vvv.display_id
                  // );
                  if (v.riderId == vvv.display_id) {
                    riderDisplayId = vvv.display_id;
                    riderId = vvv._id;
                    rider = vvv.fullName;
                  }
                });
              shift_data.push({
                shiftId: shiftId,
                shiftDisplayId: shiftDisplayId,
                shiftZone: shiftZone,
                riderId: riderId,
                riderDisplayId: riderDisplayId,
                rider: rider,
              });
            });
          }
          // console.log("rider shift", shift_data);

          // return null;
          const initialValues = {
            rider_shift_data: shift_data,
          };

          // console.log("riderShiftData", initialValues);
          setInitialValues(initialValues);
          // return;
          // let a = 0;

          // while (a < data.length) {
          //   const setUploadFileData = {
          //     tszone: data[a].zone,
          //     tsstartTimeInSec: convertDateToSecond(data[a].startTime),
          //     tsshiftDuration: data[a].shiftDuration,
          //     tsslots: data[a].slots,
          //   };

          // setUploadBulkData(Object.values(setUploadFileData));

          // const arr1 = new Array(data.length).fill(
          //   Object.values(setUploadFileData)
          // );
          // const arr1 = new Array(12).fill(Object.values(setUploadFileData));
          // const itemData = Object.values(setUploadFileData);
          // const arr1 = itemData.map((item, index) => item + index);
          // 👇️ ['value', 'value', 'value']
          // console.log(arr1);
          // setUploadBulkData([...uploadBulkData, setUploadFileData]);

          // console.log(Object.values(setUploadFileData));

          //   a++;
          // }

          resolve(data);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
      promise.then((d) => {
        setData("");
        setData(d);
      });
      setLoading(false);
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  const onInputChange = (key, index) => (e) => {
    const newData = [...data];
    newData[index][key] = e.target.value;
    // if (newData[index][key] === 0 && key === "goals") {
    //   // if (!assists) {
    //   setError(true);
    //   return null;
    //   // }
    // } else {
    //   setError(false);
    // }
    // setTotal(newData, index);
    // slotsPercentage
    let isError = false;
    const errorMsg = data.map((newData, key) => {
      let error = {};
      if (!newData.slotsPercentage) {
        error.errorslotsPercentage = "Slot Percentage is required";
        // CHANGE HERE: set error flag
        isError = true;
      } else {
        error.errorslotsPercentage = "";
      }
      if (!newData.startDisplayHours) {
        error.errorstartDisplayHours = "Show Time is required";
        // CHANGE HERE: set error flag
        isError = true;
      } else {
        error.errorstartDisplayHours = "";
      }
      if (!newData.endDisplayHours) {
        error.errorendDisplayHours = "Expiry Time is required";
        // CHANGE HERE: set error flag
        isError = true;
      } else {
        error.errorendDisplayHours = "";
      }
      return error;
    });
    // console.log("all error", errorMsg);
    setFormError(errorMsg);
    // CHANGE HERE: return false and prevent form submission in case of errors
    if (isError) return false;
    // console.log("new data", newData);
    setData(newData);
  };

  const onConfirm = async (e) => {
    const newData = [...data];
    // console.log("confirm button data", newData);
    return null;
    // }
    // newData.map((v,i)=>{
    //   let isEmpty = formObjectIsEmpty(v)
    //   if(isEmpty){
    //     setIsError({index: i, message: "Data in rows is either null or empty string"})
    //     return;
    //   }

    //   let batchId = v.batch.id
    //   let value = v
    //   delete value["id"]
    //   delete value["batch"]
    //   delete value["created_at"]
    //   batch_data.push({...v, batchId })
    // })
    // console.log("data ",batch_data)
    // console.log("batch data", batch_data)
    const bulk_rider_batch_data = newData;
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const resp = await BulkRiderBatch(bulk_rider_batch_data);
      // console.log("bulk rider batches update", resp.data);
      if (resp.data.code == 200) {
        swalNotification("Rider Batch Assign", resp.data.message, "success");
        navigate("/rider");
      }
    } catch (error) {
      swalNotification("There was an error!", error.message, "error");
      // console.error("There was an error!", error.message);
    }
  };

  const [shiftMongoIDs, setShiftMongoIDs] = useState(null);
  const [riderMongoIDs, setRiderMongoIDs] = useState(null);

  const [mongoIds, setMongoIds] = useState({ sMIds: null, rMIds: null });

  const shiftRiderMongoIDs = async (shiftIds, mongoIds) => {
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const shift_mongo_ids = await getShiftMongoIDs(shiftIds);
      if (shift_mongo_ids.data.code == 200) {
        // console.log("get shift mongi ids ", shift_mongo_ids.data.data);
        mongoIds.sMIds = shift_mongo_ids.data.data;
        setShiftMongoIDs(shift_mongo_ids.data.data);
        // openNotification("Bulk Rider Shift Assign", resp.data.message, "success");
        // navigate("/shifts");
      }
      const rider_mongo_ids = await getRiderMongoIDs(mongoIds, headers);
      if (rider_mongo_ids.data.code == 200) {
        // console.log("get rider mongi ids ", rider_mongo_ids.data.data);
        mongoIds.rMIds = rider_mongo_ids.data.data;
        setRiderMongoIDs(rider_mongo_ids.data.data);
        // openNotification("Bulk Rider Shift Assign", resp.data.message, "success");
        // navigate("/shifts");
      }
      return mongoIds;
    } catch (error) {
      validationErrors(error);
    }
  };

  const onFinish = async (values) => {
    setShowSubmitLoder(true);
    // console.log("ddd", values.rider_shift_data);
    const newData = values.rider_shift_data;
    // console.log("ddd", newData);
    // return null;
    let shiftIDs = [];
    let riderIDs = [];
    newData.map((v, i) => {
      shiftIDs.push(v.shiftDisplayId);
      riderIDs.push(v.riderDisplayId);
    });
    // console.log("shift IDs ", shiftIDs, "rider IDs", riderIDs);
    // let displayIds = "";
    const ShiftDisplayIds = { displayIds: shiftIDs };
    const RiderDisplayIds = { displayIds: riderIDs };
    // console.log("shift display ids", ShiftDisplayIds, "rider display ids", RiderDisplayIds);
    // return null;
    const headers = {
      "Content-Type": "application/json",
    };

    let result = await shiftRiderMongoIDs(ShiftDisplayIds, RiderDisplayIds);
    // console.log("function call ", result)

    // console.log("shift and rider display ids ", ShiftDisplayIds, RiderDisplayIds);
    let riderShiftMongoIDs = [];
    // if (ShiftDisplayIds != "" && RiderDisplayIds != "") {
    //   try {
    //     const shift_mongo_ids = await getShiftMongoIDs(ShiftDisplayIds, headers);
    //     if (shift_mongo_ids.data.code == 200) {
    //       console.log("get shift mongi ids ", shift_mongo_ids.data.data);
    //       setShiftMongoIDs(shift_mongo_ids.data.data);
    //       // openNotification("Bulk Rider Shift Assign", resp.data.message, "success");
    //       // navigate("/shifts");
    //     }
    //     const rider_mongo_ids = await getRiderMongoIDs(RiderDisplayIds, headers);
    //     if (rider_mongo_ids.data.code == 200) {
    //       console.log("get rider mongi ids ", rider_mongo_ids.data.data);
    //       setRiderMongoIDs(rider_mongo_ids.data.data);
    //       // openNotification("Bulk Rider Shift Assign", resp.data.message, "success");
    //       // navigate("/shifts");
    //     }
    //   } catch (error) {
    //     validationErrors(error);
    //   }

    // try {
    //   const resp = await getRiderMongoIDs(RiderDisplayIds, headers);
    //   if (resp.data.code == 200) {
    //     console.log("get rider mongi ids ", resp.data.data);
    //     setRiderMongoIDs(resp.data.data);
    //     // openNotification("Bulk Rider Shift Assign", resp.data.message, "success");
    //     // navigate("/shifts");
    //   }
    // } catch (error) {
    //   validationErrors(error);
    // }
    // console.log("shift and rider mongi ids ", result);
    // return null;
    if (result.sMIds.length > 0 && result.rMIds.length > 0) {
      newData.map((v, i) => {
        // console.log("shift display id ", v);
        // return null;
        let shiftId = "";
        let riderId = "";
        result.sMIds &&
          result.sMIds.length > 0 &&
          result.sMIds.map((vv, ii) => {
            // console.log(
            //   "value shift id and display id",
            //   v.shiftDisplayId,
            //   vv.display_id
            // );
            if (v.shiftDisplayId == vv.display_id) {
              // console.log("get shift single mongo id", vv._id);
              shiftId = vv._id;
            }
          });
        result.rMIds &&
          result.rMIds.length > 0 &&
          result.rMIds.map((vvv, ii) => {
            // console.log("get rider single mongo id", vvv._id);
            // console.log(
            //   "value shift id and display id",
            //   v.riderDisplayId,
            //   vvv.display_id
            // );
            if (v.riderDisplayId == vvv.display_id) {
              riderId = vvv._id;
            }
          });
        riderShiftMongoIDs.push({ shiftId: shiftId, riderId: riderId });
      });
      // return null;
    }
    // }
    // return null;
    // let batch_data = [];
    // newData.map((v, i) => {
    //   let batchId = v.batch.id;
    //   let value = v;
    //   delete value["id"];
    //   // delete value["batch"]
    //   delete value["created_at"];
    //   batch_data.push({ ...v, batchId });
    // });
    // console.log("batch data", batch_data);
    // batch_data.map((v, i) => {
    //   delete v["batch"];
    // });
    // console.log("data ",batch_data)
    // return null;
    // console.log("batch data", batch_data)
    // const batch_default_config_data = batch_data;
    // const headers = {
    //   "Content-Type": "application/json",
    // };
    try {
      const resp = await BulkRiderShift(riderShiftMongoIDs, headers);
      // console.log("rider batch bulk assign ", resp.data);
      if (resp.data.code == 200) {
        swalNotification(
          "Bulk Rider Shift Assign",
          resp.data.message,
          "success"
        );
        navigate("/shifts");
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      setShowSubmitLoder(false);
    }
  };

  // const initialValues1 = {
  //   rider_batchs_data: [
  //     { riderId: 3, batchId: "62fe0e265d73bd6d1bdf43c6", __rowNum__: 1 },
  //     { riderId: 5, batchId: "62fe0e265d73bd6d1bdf43c7", __rowNum__: 2 },
  //   ],
  // };

  // console.log("initial data", initialValues);

  return loading ? (
    <Pageloader />
  ) : (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch-title">
          <Title className="rockyTitle" level={2}>
            Rider {pagename} Bulk Assign
          </Title>
        </div>
        <div className="pch-content">
          <Upload className="rockyupload" {...props}>
            <Button disabled={fileList.length === 1} icon={<UploadOutlined />}>
              Select File
            </Button>
          </Upload>
          <Button>
            <Link
              to="/files/sample-file-bulk-rider-shift.csv"
              target="_blank"
              download
            >
              <DownloadOutlined /> Download Sample File
            </Link>
          </Button>
          {/* <Button
            // onClick={handleUpload}
            onClick={onConfirm}
            disabled={fileList.length === 0}
            loading={uploading}
          >
            {uploading ? "Uploading" : "Start Upload"}
          </Button> */}
          <Button onClick={() => navigate("/shifts")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>
      {initialValues && (
        <FormShiftRider
          initialValues={initialValues}
          onFinish={onFinish}
          showSubmitLoder={showSubmitLoder}
        />
      )}
    </div>
  );
};

export default RiderShiftBulkAssignment;
